import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';

const replacePriceAndRetailers = ({ text, price, numberOfRetailers }) =>
  R.compose(
    R.replace('{price}', `[b]${price}[/b]`),
    R.replace('{number}', numberOfRetailers)
  )(text);

const NumberOfRetailers = ({
  numberOfRetailers,
  inStock,
  price,
  fromRetailersLabel,
  priceRetailersSingularLabel,
  priceRetailersPluralLabel,
}) => (
  <>
    {numberOfRetailers > 0 && inStock && price && (
      <div className="number-retailers">
        {fromRetailersLabel}
        <br />
        {numberOfRetailers === 1 && (
          <BBCodeParser>
            {replacePriceAndRetailers({
              text: priceRetailersSingularLabel,
              price,
              numberOfRetailers,
            })}
          </BBCodeParser>
        )}
        {numberOfRetailers > 1 && (
          <BBCodeParser>
            {replacePriceAndRetailers({
              text: priceRetailersPluralLabel,
              price,
              numberOfRetailers,
            })}
          </BBCodeParser>
        )}
      </div>
    )}
  </>
);

NumberOfRetailers.propTypes = {
  numberOfRetailers: PropTypes.number,
  inStock: PropTypes.bool,
  price: PropTypes.number,
  fromRetailersLabel: PropTypes.string,
  priceRetailersSingularLabel: PropTypes.string,
  priceRetailersPluralLabel: PropTypes.string,
};

export default NumberOfRetailers;
